export const questions = [
  {
    id: 1,
    type: "select",
    name: "housingSuitability",
    title: "What size is your home?",
    param: "housingSuitability",
    options: [
      { label: "Small", value: "small", desc: "20-40 kvm" },
      { label: "Medium", value: "medium", desc: "40-80 kvm" },
      { label: "Large", value: "large", desc: "80-150 kvm" },
    ],
  },
  {
    id: 1111,
    type: "select",
    name: "outdoorSituation",
    title: "How will the dogs outdoor situation be?",
    param: "outdoorSituation",
    options: [
      { label: "City living", value: "city", desc: "Busy- traffic- and noisy areas" },
      {
        label: "Suburban areas",
        value: "suburban",
        desc: "Quieter neighborhoods, access to parks and green spaces",
      },
      {
        label: "Rural / nature-focused environments",
        value: "rural",
        desc: "Frequent access to forests, fields, or large outdoor areas",
      },
    ],
  },
  {
    id: 2,
    type: "radio",
    name: "childrenSuitability",
    title: "Will the dog live with children under 12?",
    param: "childrenSuitability",
    options: [
      { label: "Yes", value: "yes" },
      { label: "No", value: "no" },
    ],
  },
  {
    id: 3,
    type: "select",
    name: "dogsSuitability",
    param: "dogsSuitability",
    title: "Will the dog live with other dogs?",
    options: [
      { label: "Yes", value: "yes" },
      { label: "No", value: "no" },
      { label: "Possibly in the future", value: "unknown" },
    ],
  },
  {
    id: 3333,
    type: "select",
    name: "animalsSuitability",
    param: "animalsSuitability",
    title: "Will the dog live with other animals?",
    options: [
      { label: "Yes", value: "yes" },
      { label: "No", value: "no" },
      { label: "Possibly in the future", value: "unknown" },
    ],
  },
  {
    id: 4,
    type: "select",
    name: "allergySuitability",
    param: "allergySuitability",
    title: "Have there been fur allergies in the family?",
    options: [
      { label: "Yes", value: "yes" },
      { label: "No", value: "no" },
      { label: "Unsure", value: "unknown" },
    ],
  },
  {
    id: 5,
    type: "select",
    name: "aloneTolerance",
    param: "aloneTolerance",
    title: "On a typical weekday, for how many hours will the dog be alone?",
    options: [
      { label: "1-3 hours", value: "1" },
      { label: "4-6 hours", value: "4" },
      { label: "7+ hours", value: "7" },
    ],
  },
  {
    id: 6,
    type: "select",
    name: "activityLevel",
    param: "activityLevel",
    title: "How would you best describe your everyday lifestyle?",
    options: [
      {
        label: "Very active",
        value: "high",
        desc: "Long walks, frequent outdoor activities, running, hiking, or sports",
      },
      {
        label: "Moderately active",
        value: "moderate",
        desc: "Daily walks, some longer outings, occasional exercise or adventures",
      },
      {
        label: "Mostly calm",
        value: "low",
        desc: "Short daily walks, relaxed pace, lots of downtime",
      },
    ],
  },
  // {
  //   id: 7,
  //   type: "select",
  //   name: "size",
  //   param: "size",
  //   title: "What size of dog do you feel comfortable with?",
  //   options: [
  //     { label: "Small", value: "small" },
  //     { label: "Medium", value: "medium" },
  //     { label: "Large", value: "large" },
  //   ],
  // },
  {
    id: 8,
    type: "select",
    name: "adaptability",
    title:
      "During the dog’s first year with you, how often do you expect it to stay with someone else (for example, due to travel or work)?",
    param: "adaptability",
    options: [
      { label: "Rarely", value: "no", desc: "Mostly at home, little to no travel" },
      {
        label: "Occasionally",
        value: "medium",
        desc: "Short trips or a few stays with friends, family, or boarding",
      },
      {
        label: "Regularly",
        value: "adaptable",
        desc: "Frequent travel or recurring stays with others",
      },
    ],
  },
  {
    id: 9,
    type: "select",
    name: "experience",
    param: "experience",
    title: "What is your experience with dogs?",
    options: [
      { label: "This would be my first dog", value: "no" },
      { label: "I’ve lived with or cared for dogs before", value: "some" },
      {
        label: "I have extensive experience",
        value: "yes",
        desc: "Training, long-term ownership, or caring for multiple dogs",
      },
    ],
  },
  {
    id: 10,
    type: "select",
    name: "supportLevel",
    param: "supportLevel",
    title: "What kind of everyday support and routine can you offer this dog?",
    options: [
      {
        label: "A very stable, supportive routine",
        value: "stable",
        desc: "Predictable days, lots of presence, and time to help a dog settle in",
      },
      {
        label: "A mostly stable routine",
        value: "regular",
        desc: "Regular structure, with some flexibility or occasional changes",
      },
      {
        label: "A flexible, changing routine",
        value: "flexible",
        desc: "Varying days, less structure, or frequent changes",
      },
    ],
  },
  // {
  //   id: 10,
  //   type: "select",
  //   name: "energyLevel",
  //   param: "energyLevel",
  //   title: "Do you prefer a calm or energetic dog indoors?",
  //   options: [
  //     { label: "Calm", value: "calm" },
  //     { label: "Mix", value: "balanced" },
  //     { label: "Energetic", value: "high" },
  //   ],
  // },
  // {
  //   id: 11,
  //   type: "select",
  //   name: "groomingNeeds",
  //   param: "groomingNeeds",
  //   title: "How much grooming are you comfortable with?",
  //   options: [
  //     { label: "Minimal", value: "1" },
  //     { label: "Weekly", value: "2" },
  //     { label: "Daily", value: "3" },
  //   ],
  // },
  // {
  //   id: 12,
  //   type: "select",
  //   name: "temperament",
  //   param: "temperament",
  //   title: "What is your ideal dog temperament?",
  //   options: [
  //     { label: "Independent", value: "independent" },
  //     { label: "Balanced", value: "balanced" },
  //     { label: "Very affectionate", value: "attention" },
  //   ],
  // },
  {
    id: 13,
    type: "select",
    name: "insurance",
    title:
      "Would you like to quickly and easily create an insurance plan tailored for your dog through our partner Lassie?",
    options: [
      { label: "Yes, I am interested", value: "yes" },
      { label: "Maybe later", value: "maybe" },
      { label: "No, thanks", value: "no" },
    ],
  },
  {
    id: 14,
    type: "select",
    name: "foodSubscription",
    title:
      "Would you like to subscribe to Tailtales dog food, tailored to your chosen dog's needs, delivered straight to your door?",
    options: [
      { label: "Yes, subscribe", value: "yes" },
      { label: "Maybe later", value: "maybe" },
      { label: "No, thanks", value: "no" },
    ],
  },
];
